module.exports = __webpack_public_path__ + "img/05.3dcc95ac.jpg";